import { Parse } from 'parse';
import * as FUNCTION_NAMES from './functionNames';

const cloudFunctionRun = (functionName, params) => {
	return Parse.Cloud.run(functionName, params);
};

const cloudFunctionRunProvider = (provider, functionName, params) => {
	return provider.runCloudFunction(functionName, params);
};

export const requestVerificationCode = (provider, phone) => cloudFunctionRunProvider(
	provider, FUNCTION_NAMES.REQUEST_VERIFICATION_CODE_BY_ADMIN, { phone },
);

export const createTradeUnion = (params) => cloudFunctionRun(
	FUNCTION_NAMES.CREATE_TRADE_UNION, params,
);

export const checkCardUniqueness = (cardId, tradeUnionId, id) => cloudFunctionRun(
	FUNCTION_NAMES.CHECK_CARD_UNIQUENESS, { cardId, tradeUnionId, id },
);

export const getUserPermissions = () => cloudFunctionRun(
	FUNCTION_NAMES.GET_USER_PERMISSIONS, {},
);

export const checkLocationLabelUniqueness = (label, id) => cloudFunctionRun(
	FUNCTION_NAMES.CHECK_LOCATION_LABEL_UNIQUENESS, { label, id },
);

export const createProfileByAdmin = (params) => cloudFunctionRun(
	FUNCTION_NAMES.CREATE_PROFILE_BY_ADMIN, params,
);
